import { createFileRoute } from '@tanstack/react-router';
import { SemanticModelDetailPage } from '@/features/metric-hub/semantic-models/SemanticModelDetailPage';

export const Route = createFileRoute('/_authed/metric-hub/semantic-models/$name')({
  component: SemanticModelDetailRoute,
});

function SemanticModelDetailRoute() {
  const { name } = Route.useParams();
  return <SemanticModelDetailPage name={name} />;
}
